import { render, staticRenderFns } from "./MarketingFAQ.vue?vue&type=template&id=33d68262&"
import script from "./MarketingFAQ.vue?vue&type=script&lang=ts&"
export * from "./MarketingFAQ.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingFAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports